import { ChangeEvent, memo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  getWebPageVariant,
  WebPageType,
} from '../../../../constants/webPageType';
import {
  LoadingSpinner,
  TextButton,
  TextButtonSize,
  TextInput,
} from '../../../Molecules';

import './ResetPasswordTemplate.css';

type TextInputProps = {
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

type ResetPasswordTemplateProps = {
  webPageType: WebPageType;
  retypePassword: TextInputProps;
  password: TextInputProps;
  errorMessage: string;
  isLoading: boolean;
  onClick: () => void;
};

export const ResetPasswordTemplate = memo(
  ({
    webPageType,
    retypePassword,
    password,
    errorMessage,
    isLoading,
    onClick,
  }: ResetPasswordTemplateProps) => {
    const { t } = useTranslation();
    return (
      <div className="reset-password">
        <div className="centered-container">
          <img className="logoTop" src={getWebPageVariant(webPageType).logo} />
          <p
            className={`reset-title ${
              getWebPageVariant(webPageType).classVariantLight2
            }`}
          >
            {t('Reset Password')}
          </p>
          <TextInput
            value={password.value}
            onChange={password.onChange}
            placeholder={t('Password')}
            type="password"
            style={{ backgroundColor: '#f0f0f0' }}
          />
          <TextInput
            value={retypePassword.value}
            onChange={retypePassword.onChange}
            placeholder={t('Retype Password')}
            type="password"
            style={{ backgroundColor: '#f0f0f0' }}
          />
          {<div className="warning">{t(errorMessage)}</div>}
          <TextButton
            text={t('Confirm')}
            size={TextButtonSize.Medium}
            variant={getWebPageVariant(webPageType).textButtonVariant}
            onClick={onClick}
          />
        </div>
        {isLoading && <LoadingSpinner loading={isLoading} />}
      </div>
    );
  },
);
